import { Button, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { usagelogApi } from "../../api/usageReportApi";
import GreyOpenLock from "../../assets/images/open-gray-lock.svg";
import GreenOpenLock from "../../assets/images/open-green-lock.svg";
import { useAppSelector } from "../../store/hooks";

const DownloadButton = (props: any) => {
  const { link, articleData, resultFrom, greenLockUrl } = props;
  const fullText = useAppSelector((state) => state?.searchReducer?.fullText);

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("md"));
  // console.log("fullText", fullText);

  const profileData1 = useAppSelector(
    (state) => state.customer.customerDetails,
  );

  const profileData = useAppSelector((state) => state.login);

  const selectedCollectionFromSearchResultPageAndAuthorFinder = useAppSelector(
    (state: any) => state.filterReducer,
  );
  const selectedCollectionFromBrowseJournalSearch = useAppSelector(
    (state: any) => state.browseFilterSlice,
  );

  const is_ONOSCustomer = useAppSelector(
    (state: any) => state.customer.customerDetails?.is_enable_onos,
  );

  const isAIMode = useAppSelector((state) => state.aiMode.isAIMode);

  function getContextId(collectionValue: any) {
    switch (collectionValue) {
      case "J-GateCollection":
        return 1;
      case "ConsortiaSubscriptions":
        return 2;
      case "MyLibraryCollection":
        return 3;
      case "MyPersonalLibraryCollection":
        return 4;
      case "ONOSCollections":
        return 5;
      case "Library OPAC":
        return 6;
      case "Open Access Collections":
        return 7;
      default:
        return null;
    }
  }

  function getContextIdFromJournal(collectionValue: any) {
    switch (collectionValue) {
      case "J-GateCollection":
        return 1;
      case "Consortia Collections":
        return 2;
      case "My Library Collections":
        return 3;
      case "MyPersonalLibraryCollection":
        return 4;
      case "ONOS Collections":
        return 5;
      case "Library OPAC":
        return 6;
      case "Open Access Collections":
        return 7;
      default:
        return null;
    }
  }

  const contextIdFromfilterReducer = getContextId(
    selectedCollectionFromSearchResultPageAndAuthorFinder.collectionValue,
  );

  const contextIdFromBrowseFilterSlice = getContextIdFromJournal(
    selectedCollectionFromBrowseJournalSearch.collectionsValueJournal,
  );

  const contextId =
    resultFrom === "searchResult" || resultFrom === "authorFinder"
      ? contextIdFromfilterReducer
      : resultFrom === "BrowseJournalTableSearch/BrowseJournalSearch"
        ? contextIdFromBrowseFilterSlice
        : null;
  const logUsageAccessButtonData = (usageActionID: any, details?: any) => {
    const userId = sessionStorage.getItem("user_id");
    const informaticscustomer_Id = sessionStorage.getItem(
      "informaticscustomer_id",
    );
    // const articleArticle_Id = details?.article_id ? details?.article_id : null;
    const articleArticle_Id =
      details?.data_type === "Books" && !details?.has_chapter
        ? null
        : (details?.article_id ?? null);
    const articleResourcemaster_id = details?.resourcemaster_id
      ? details?.resourcemaster_id
      : null;
    const articleResourceissue_id = details?.resourceissue_id
      ? details?.resourceissue_id
      : null;
    const publisherId = details?.publisher_id ? details?.publisher_id[0] : null;
    const user_ipv4_address =
      sessionStorage.getItem("user_ipv4_address") || null;

    const userMasterId = profileData.user_id
      ? profileData.user_id
      : userId
        ? userId
        : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : informaticscustomer_Id
        ? informaticscustomer_Id
        : null;
    const consortiamasterId =
      profileData1 && profileData1.consortiamaster_id
        ? profileData1.consortiamaster_id
        : null;
    const sessionKey = profileData.session_key ? profileData.session_key : null;
    const isArticleONOS = details?.is_onos_resource;
    const isONOS =
      is_ONOSCustomer &&
      (selectedCollectionFromSearchResultPageAndAuthorFinder.collectionValue ===
        "ONOSCollections" ||
        selectedCollectionFromBrowseJournalSearch.collectionsValueJournal ===
          "ONOS Collections" ||
        isArticleONOS)
        ? 1
        : 0;
    const bookId = details?.bookmaster_id ?? null;
    const isAISearch = isAIMode ? true : false;
    usagelogApi(
      userMasterId,
      informaticscustomerId,
      consortiamasterId,
      usageActionID,
      contextId,
      null,
      articleArticle_Id,
      articleResourceissue_id,
      publisherId,
      articleResourcemaster_id,
      // profileData.ip_v4,
      user_ipv4_address,
      null,
      sessionKey,
      1,
      null,
      isONOS,
      bookId,
      isAISearch,
    );
  };

  const handlePatentSubmit = async (applicationNumber: string) => {
    const formData = new FormData();

    formData.append("ApplicationNumber", applicationNumber);
    formData.append("ConnectionName", "PublicationConnection");

    try {
      const response = await fetch(
        "https://iprsearch.ipindia.gov.in/PublicSearch/PublicationSearch/PatentDetails",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await response.text();

      console.log(data);
    } catch (error) {
      console.error("Patent API Error:", error);
    }
  };
  return (
    <Stack direction="row" spacing={2}>
      <Tooltip
        title={
          articleData?.data_type === "Pre-Print"
            ? "Preprint version"
            : articleData?.data_type === "Datasets"
              ? "Access Unknown: Check Availability"
              : "Open Access Article"
        }
      >
        {articleData?.data_type === "Datasets" ? (
          <Button
            // sx={{ color: "#6b7280", borderColor: "#6b7280" }}
            color="secondary"
            variant="outlined"
            href={link && link}
            target="_blank"
            rel="noopener noreferrer"
            download={"true"}
            // startIcon={<img src={GreyOpenLock} />}
            startIcon={<img src={GreenOpenLock} />}
            onClick={
              fullText
                ? () => logUsageAccessButtonData(35, articleData)
                : () => logUsageAccessButtonData(32, articleData)
            }
            size={isXs ? "small" : "medium"}
          >
            Access Full Text
          </Button>
        ) : articleData?.data_type === "Books" ? (
          <Button
            // sx={{ color: "#6b7280", borderColor: "#6b7280" }}
            color="secondary"
            variant="outlined"
            href={link && link}
            target="_blank"
            rel="noopener noreferrer"
            download={"true"}
            // startIcon={<img src={GreyOpenLock} />}
            startIcon={<img src={GreenOpenLock} />}
            onClick={
              articleData?.has_chapter
                ? () => logUsageAccessButtonData(131, articleData)
                : () => logUsageAccessButtonData(132, articleData)
            }
            size={isXs ? "small" : "medium"}
          >
            Access Full Text
          </Button>
        ) : articleData?.data_type === "Patents" &&
          (Array.isArray(articleData?.publisher_id)
            ? articleData.publisher_id.includes(52298)
            : articleData?.publisher_id === 52298) ? (
          <Button
            color="secondary"
            variant="outlined"
            href={link || undefined}
            target="_blank"
            rel="noopener noreferrer"
            download
            startIcon={<img src={GreenOpenLock} alt="Open lock" />}
            onClick={
              () => handlePatentSubmit(articleData?.application_no)
              // logUsageAccessButtonData(
              //   articleData?.has_chapter ? 131 : 132,
              //   articleData,
              // )
            }
            size={isXs ? "small" : "medium"}
          >
            Access Full Text
          </Button>
        ) : (
          <Button
            color="secondary"
            variant="outlined"
            href={link && link}
            target="_blank"
            rel="noopener noreferrer"
            download={"true"}
            startIcon={<img src={GreenOpenLock} />}
            onClick={() => {
              articleData?.data_type === "Pre-Print" && fullText
                ? logUsageAccessButtonData(35, articleData)
                : logUsageAccessButtonData(32, articleData);
              // if (link) {
              // const win = window.open(link, "_blank", "noopener,noreferrer");
              // if (win) {
              // Delay actual navigation to avoid Chrome blocking tab
              // setTimeout(() => {
              //   win.location.href = link;
              //   window.location.reload()
              // }, 0);
              // small delay helps Chrome treat it as valid navigation
              // }
              // }
            }}
            size={isXs ? "small" : "medium"}
          >
            Access Full Text
          </Button>
        )}
      </Tooltip>
    </Stack>
  );
};

export default DownloadButton;

const webStyles = {};
